export const ErrorContent = {
  sectionErrorTitle: 'It looks like something went wrong.',
  sectionErrorDescription: 'Please try again later',
};

export const ProfileBlockContent = {
  noRoleContent:
    'Hello! No specific content is available for your current role yet.  It is being actively worked on.  Meanwhile, explore roles within the Role Library and reach out to your Manager for career planning support.',
};

export const faqContent = [
  {
    header: 'When should I use Role Library? What are the benefits?',
    mainContent:
      'Role Library can help you to think about your skills and interests and explore relevant roles. The Role Library can help by:',
    listItems: [
      "Providing clarity on the role I'm in today",
      'Identifying skills and qualifications needed for my next role',
      'Informing the creation of an individual development plan taking into consideration my career aspirations',
      'Identifying transferrable skills or where I need to upskill',
      "During the Connect process - identify skills I've excelled in and areas of future development",
      'Perspectives - I want to obtain insights on a role in order to give specific feedback to my requester',
      "As a manager, preparing for my employee's Connect and preparing to have a meaningful career conversation with my employee",
    ],
  },
  {
    header: 'What is a Role Description?',
    mainContent:
      'A Role Description describes the key responsibilities, qualifications and skills critical or important for each role at Microsoft, and supports career development, hiring and selection. A role description describes What you do (responsibilities), How you do it (skills and capabilities), and What is needed (qualifications).',
  },
  {
    header: 'What does my career stage mean?',
    mainContent:
      'Career stage indicates the degree of scope and complexity of a role and is consistent across professions, disciplines, and countries. For example, employees who are in a career stage 3 role in Finance or employees in career stage 3 in Software Engineering have a similar set of general expectations in their respective fields. While roles in the same career stage are at the same place in their career, the type of work performed, deliverables, and qualifications are specific to each discipline.',
  },
  {
    header: 'What can I ask Role Library Assistant?',
    mainContent:
      'You can ask questions about professions, disciplines and role information e.g. requirements for a role or skills comparisons between roles. You can also ask the model to summarize information about a role or set of skills. Answers generated in the Role Library Assistant will be based on the content available in the Role Library, not your personal history or skills profile.',
  },
  {
    header: 'Will the AI model provide suggestions for Learning or other Career Development resources?',
    mainContent:
      'No. Role Library Assistant only has access to information about Professions, Disciplines, Roles and Skills in the Role Library. Job and learning recommendations are included in the future tech roadmap. ',
  },
];
